module.exports = __webpack_public_path__ + "img/mr_look.46328b10.svg";